// src/components/UserProfile.js
import React, { useState } from 'react';
import { Box, Avatar, Typography, Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const UserProfile = () => {
  const { user, signOut } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  
  const handleSignOut = async () => {
    await signOut();
    handleCloseMenu();
  };
  
  if (!user) return null;
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
        {user.email}
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          mr: 2, 
          display: { xs: 'none', sm: 'block' },
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          textTransform: 'capitalize'
        }}
      >
        {user.role}
      </Typography>
      
      <Tooltip title="Account settings">
        <IconButton onClick={handleOpenMenu} size="small">
          {user.picture ? (
            <Avatar 
              src={user.picture} 
              alt={user.email || ''} 
              sx={{ width: 40, height: 40 }}
            />
          ) : (
            <Avatar sx={{ width: 40, height: 40, bgcolor: '#90caf9' }}>
              {user.email?.charAt(0).toUpperCase() || 'U'}
            </Avatar>
          )}
        </IconButton>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {/* <MenuItem onClick={handleCloseMenu}>
          <AccountCircleIcon sx={{ mr: 1 }} /> Profile
        </MenuItem> */}
        <MenuItem onClick={handleSignOut}>
          <LogoutIcon sx={{ mr: 1 }} /> Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserProfile;